//jquery
import $ from 'jquery';
window.jQuery = window.jQuery || $;
window.$ = window.$ || $;

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';

import {initBarkEntryService} from "../new-request-flow/components/entry-service/start-bark";
import {default as StreamComplete} from '../legacy-scripts/streamcomplete';
import {setBarkLandingPageCookie, setInitialReferrerCookie, setPaidMarketingSessionCookie} from "../tracking";
import {initCategoryAutocompleteForInput} from "../autocomplete-inputs/category-autocomplete";
import {
    getPayloadForStartBarkFromHeader
} from "../new-request-flow/components/entry-service/create-bark-payload";
import {
    setupDynamicPostCodeAutocomplete,
} from "../autocomplete-inputs/postcode-autocomplete";
import {
    default as BarkLib,
    exposeBarkLibFunctionsToTheWindow
} from "../legacy-scripts/barklib";

import {DirectoryExplore, FooterJs} from "../navigation";
import '../onetrust/onetrust';
import { init as initHeapServerSideTracking } from '../analytics/heap-server-side';
import { initDataDogRum } from '../datadog/start-datadog';

// run
export const initMarketingPage = async () => {
	initDataDogRum();
	BarkLib();
	exposeBarkLibFunctionsToTheWindow();
	initBarkEntryService();
	DirectoryExplore();
	StreamComplete(0, window, window.document);
	setUpAutoCompletes();
	// Drop a couple of cookies to help us track organic barks
	setInitialReferrerCookie();
	setBarkLandingPageCookie();
	setPaidMarketingSessionCookie();
	FooterJs();
	initHeapServerSideTracking();
};

const setUpAutoCompletes = () => {
    if (document.getElementById('category_id')) {
        initCategoryAutocompleteForInput('category_name', 'category_id');
    }

    if (document.getElementById('category_name_top')) {
        initCategoryAutocompleteForInput('category_name_top', 'category_id_top',{
            isStartBark: true,
            payload: getPayloadForStartBarkFromHeader,
        });
    }
    if (document.getElementById('postcode')) {
        setupDynamicPostCodeAutocomplete('postcode');
    }
}

